import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';

import Login from "./pages/Login"; 
import Dashboard from "./pages/Dashboard";
import Tables from "./pages/Tables";
import Menu from "./pages/Menu";
import Billing from "./pages/Billing";
import Reports from "./pages/Reports"; 
import Settings from "./pages/Settings"; // Added this import

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Login is the first page everyone sees */}
        <Route path="/" element={<Login />} /> 
        <Route path="/login" element={<Login />} />

        {/* Dashboard & Management Routes */}
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/tables" element={<Tables />} />
        <Route path="/menu" element={<Menu />} />
        <Route path="/billing" element={<Billing />} />
        <Route path="/billing/:tableId" element={<Billing />} />
        <Route path="/reports" element={<Reports />} />
        
        {/* Settings Route - Fixed the blank page issue */}
        <Route path="/settings" element={<Settings />} />

        {/* Redirect any typos back to Login */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;